@if (isDataLoaded) {
<div *ngIf="isHaveSubscription && !isTrialCompleted && !isCompleted" class="sub-block">
  <div class="main-block">
    <div class="left-block">
      <div class="sub-header">
        <div class="sub-header-text">Подписка</div>
        <div class="sub-header-logo"></div>
      </div>
      @if (isTrial) {
      <div class="sub-status">Активирован бесплатный период до {{activeSubscription.endDate |
        date:'shortDate': '-0000' :'ru-RU'}}</div>
      @if (activeSubscription.paymentDate) {
      <div class="sub-status gray">Способ оплаты</div>
      <div class="payment-type-block">
        <div class="payment-type-{{cardTypeName}}"></div>
        <div class="small-point"></div>
        <div class="small-point"></div>
        <div class="sub-status-payment">{{activeSubscription.paymentCardNumber}}</div>
        <div class="payment-edit"></div>
      </div>
      <div class="sub-status gray link" (click)="openDialog()">Отменить подписку</div>
      }
      @else {
      <div class="activate-btn {{buttonStyle}}" (click)="createPayment()">Подключить за
        {{activeSubscriptionPlan.totalCost}} ₽ / месяц
      </div>
      }
      }

      @if (isCancelled) {
      <div class="sub-status">Автоматическое продление отключено. Подписка закончится
        {{activeSubscription.endDate | date:'shortDate': '-0000' :'ru-RU'}}</div>
      <div class="activate-btn {{buttonStyle}}" (click)="createPayment()">Подключить за
        {{activeSubscriptionPlan.totalCost}} ₽ / месяц</div>
      }

      <div *ngIf="isDeclined" class="sub-status">Подписка не активна. {{activeSubscription.endDate | date:'shortDate':
        '-0000'
        :'ru-RU'}} следующий платеж {{activeSubscriptionPlan.totalCost}} ₽</div>

      <div *ngIf="!isTrial && !isCancelled && !isDeclined" class="sub-status-no-margin">{{activeSubscription.endDate |
        date:'shortDate': '-0000' :'ru-RU'}} cледующий платеж </div>
      <div *ngIf="!isTrial && !isCancelled && !isDeclined" class="sub-status">{{activeSubscription.totalCost}} ₽</div>
      <div *ngIf="!isTrial && !isCancelled" class="sub-status gray">Способ оплаты</div>
      <div *ngIf="!isTrial && !isCancelled" class="payment-type-block">
        <div class="payment-type-{{cardTypeName}}"></div>
        <div class="small-point"></div>
        <div class="small-point"></div>
        <div class="sub-status-payment">{{activeSubscription.paymentCardNumber}}</div>
        <div class="payment-edit"></div>
      </div>
      <div *ngIf="!isTrial && !isCancelled" class="sub-status gray link" (click)="openDialog()">Отменить подписку</div>
    </div>
    <div class="right-block">
      <circle-progress [progress]="progress"></circle-progress>
      <div class="internal-circle">
        <div class="rem-number">{{activeSubscription.remainingDays}}</div>
        <div class="rem-days">{{getRemaingDaysText(activeSubscription.remainingDays)}}</div>
      </div>
    </div>
  </div>
  @if (isTrial && activeSubscription.paymentDate) {
  <div class="next-date">{{activeSubscription.paymentDate |
    date:'shortDate': '-0000' :'ru-RU'}} начнется оплаченный период подписки. Следующее списание
    {{activeSubscription.nextPaymentDate |
    date:'shortDate': '-0000' :'ru-RU'}}</div>
  }
  @if ((isTrial && !activeSubscription.paymentDate) || isCancelled) {
  <div class="agreement">
    <input type="checkbox" class="checkbox" [(ngModel)]="isAgreementChecked" name="agreementCB"
      (change)="onAgreementChange()">
    <p class="agreement-text">
      Согласен с <a href="https://dexbee.ru/dexbee_plus_conditions">условиями подписки</a></p>
  </div>
  }
  @if (isDeclined || isNextSubscriptionDeclined) {
  <div class="next-date">Пополните счет и дождитесь очередной попытки списания платежа
    {{activeSubscription.nextTransactionDate |
    date:'shortDate': '-0000' :'ru-RU'}} в {{activeSubscription.nextTransactionDate |
    date:'HH:mm'}}. Если не хотите ждать - нажмите кнопку "Оплатить сейчас" в письме-напоминании о
    просроченном платеже или просто отмените текущую подписку и подключите новую
  </div>
  }
</div>

@if (!isHaveSubscription || isTrialCompleted || isCompleted) {
<div class="sub-block-yellow">
  <div class="na-block">
    <div class="na-header">Больше возможностей</div>
    <div class="na-sub-header">
      <div class="na-sub-header-text">Подключите подписку</div>
      <div class="sub-header-logo"></div>
    </div>
    <div class="activate-btn {{buttonStyle}} margin12" (click)="createPayment()">Подключить за
      {{activeSubscriptionPlan.totalCost}} ₽ /
      месяц
    </div>
    <div class="agreement margin0">
      <input type="checkbox" class="checkbox" [(ngModel)]="isAgreementChecked" name="agreementCB"
        (change)="onAgreementChange()">
      <p class="agreement-text">
        Согласен с <a href="https://dexbee.ru/dexbee_plus_conditions">условиями подписки</a></p>
    </div>
  </div>
</div>
}
}
@if (!isDataLoaded) {
<div class="sub-block">
  <div class="wait"></div>
</div>
}